export type Tome = {
  number: string;
  title: string;
  phrase: string;
  /** URL de la portada real. Dejar vacío ('') para mostrar la portada provisional. */
  image: string;
};
export type Tool = {
  label: string;
  title: string;
  description: string;
  /** URL de la portada real. Dejar vacío ('') para mostrar la portada provisional. */
  image: string;
};
export type InteriorPage = {
  /** URL de la página interior. */
  image: string;
  alt: string;
};
export type Testimonial = {
  quote: string;
  name: string;
  age: string;
};
export type Faq = {
  question: string;
  answer: string;
};

/** Reemplazar por la URL real del checkout. Todos los botones apuntan aquí. */
export const checkoutUrl = 'https://lo-que-nadie-ve.impultienda.ar/checkout';

/**
 * Mockup principal de la colección (PROVISIONAL).
 * Reemplazar por el archivo real; si se deja vacío se muestra la composición de portadas.
 */
export const collectionImage = 'https://cdn.magicpatterns.com/uploads/pySojB8w8xeoeyfVX6LDhR/Coleccion_Una_Mente_en_Codigo.png';
export const brand = 'UNA MENTE EN CÓDIGO';
export const productName = 'LO QUE NADIE VE';
export const price = 'US$9.90';
export const cta = {
  primary: 'QUIERO EMPEZAR A ENTENDERME',
  access: 'QUIERO ACCEDER A LO QUE NADIE VE'
};
export const hero = {
  eyebrow: 'AUTISMO ADULTO · MASKING · SOBRECARGA · AGOTAMIENTO',
  titleLine1: 'DEJA DE PENSAR',
  titleLine2Start: 'QUE EL PROBLEMA',
  titleHighlight: 'ERES TÚ.',
  subtitle: 'Por fin entiende por qué tantas cosas te agotan, te sobrecargan o te hacen sentir fuera de lugar.',
  productLine: '6 tomos + 5 bonos incluidos',
  microcopy: 'Acceso inmediato · Pago único · Garantía de 7 días'
};
export const identification = {
  titleLine1: 'SI ESTO TE RESULTA FAMILIAR,',
  titleLine2: 'HAY ALGO QUE VALE LA PENA MIRAR.',
  points: ['Después de socializar necesitas recuperarte.', 'Ensayas conversaciones o repasas después lo que dijiste.', 'Los cambios inesperados pueden desordenarte completamente.', 'Ruido, luces, conversaciones y demandas se van acumulando.', 'Puedes cumplir con todo… y terminar completamente agotado.'],
  closeLine1: 'QUE PUEDAS HACERLO',
  closeLine2: 'NO SIGNIFICA QUE TE CUESTE POCO.'
};
export const productIntro = {
  eyebrow: 'UNA FORMA DIFERENTE DE MIRAR TU HISTORIA',
  body: '6 tomos organizados para ayudarte a ponerle contexto a experiencias que quizá llevas años sintiendo sin saber cómo explicar.',
  stats: [{
    value: '6',
    label: 'TOMOS'
  }, {
    value: '5',
    label: 'BONOS PRÁCTICOS'
  }],
  badges: ['ADULTO', 'CLARO', 'VISUAL', 'CERCANO']
};
export const tomesTitle = {
  line1: '6 TOMOS PARA EMPEZAR',
  line2: 'A VER EL PATRÓN COMPLETO'
};
export const tomes: Tome[] = [{
  number: 'TOMO 1',
  title: 'LO QUE NADIE VIO',
  phrase: 'Mira tu historia con un contexto que quizá nunca tuviste.',
  image: 'https://cdn.magicpatterns.com/uploads/rV5wVxKYhz21rjCuAJmhUH/TOMO_1_page-0001.jpg'
}, {
  number: 'TOMO 2',
  title: 'LA MÁSCARA INVISIBLE',
  phrase: 'Reconoce cuánto esfuerzo puede esconderse detrás de parecer estar bien.',
  image: 'https://cdn.magicpatterns.com/uploads/jnP8sjV2BhCdPvydYqf4ik/TOMO_2_page-0001.jpg'
}, {
  number: 'TOMO 3',
  title: 'UN MUNDO DEMASIADO INTENSO',
  phrase: 'Entiende qué ocurre cuando estímulos y demandas empiezan a acumularse.',
  image: 'https://cdn.magicpatterns.com/uploads/37aNpLBJ4k3Co8t2rTcjxH/TOMO_3_page-0001.jpg'
}, {
  number: 'TOMO 4',
  title: 'EL PRECIO DE PARECER FUNCIONAL',
  phrase: 'Explora la diferencia entre poder hacer algo y el costo de sostenerlo.',
  image: 'https://cdn.magicpatterns.com/uploads/1xSUFHs8uos67WogeQdz6c/TOMO_4_page-0001.jpg'
}, {
  number: 'TOMO 5',
  title: 'CUANDO VIVIR TAMBIÉN AGOTA',
  phrase: 'Observa cómo trabajo, relaciones, rutinas y responsabilidades pueden sumarse.',
  image: 'https://cdn.magicpatterns.com/uploads/86QR9Su3vTWMwB1woLNumv/TOMO_5_page-0001.jpg'
}, {
  number: 'TOMO 6',
  title: 'AHORA QUE LO ENTIENDES, ¿QUÉ HACES CON ESTO?',
  phrase: 'Empieza a identificar necesidades, límites y próximos pasos.',
  image: 'https://cdn.magicpatterns.com/uploads/7VPDVaYTyjKrzWuEfEkxro/TOMO_6_page-0001.jpg'
}];
export const inside = {
  title: 'MIRA POR DENTRO',
  subtitle: 'No solo leas sobre el tema. Empieza a observarte.',
  features: ['Explicaciones claras', 'Ejercicios de autoobservación', 'Mapas visuales', 'Checklists', 'Preguntas guiadas']
};
/** Páginas interiores reales que se muestran en el carrusel "Mira por dentro". */
export const interiorPages: InteriorPage[] = [{
  image: 'https://cdn.magicpatterns.com/uploads/aX7vXogT65E9vqe28wB3zB/Captura_de_pantalla_2026-10-03_183231.png',
  alt: 'Página interior de Lo que nadie ve'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/iHFvSu5uJZJ4hvDVb8Ysfa/Captura_de_pantalla_2026-10-03_183147.png',
  alt: 'Página interior de Lo que nadie ve'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/cuB8Ljq81xTQuTGEtZeTtA/Captura_de_pantalla_2026-10-03_183102.png',
  alt: 'Página interior de Lo que nadie ve'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/6QTwPWeRLinNVyYRxsyosQ/Captura_de_pantalla_2026-10-03_183016.png',
  alt: 'Página interior de Lo que nadie ve'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/bwfUawD9pMq1UTi7JF5Jb6/Captura_de_pantalla_2026-10-03_182341.png',
  alt: 'Página interior de Lo que nadie ve'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/rtrTTKgh63SNMqj5ctEE6Z/Captura_de_pantalla_2026-10-03_181940.png',
  alt: 'Página interior de Lo que nadie ve'
}];
export const toolsIntro = {
  titleLine1: 'ENTENDERLO ES EL PRIMER PASO.',
  titleLine2: 'AHORA TAMBIÉN NECESITAS SABER QUÉ HACER.',
  subtitle: 'Por eso tu acceso incluye 5 bonos prácticos para llevar lo aprendido a situaciones reales.'
};
export const tools: Tool[] = [{
  label: 'BONO 1',
  title: '¿DÓNDE SE ESTÁ YENDO TODA MI ENERGÍA?',
  description: 'Detecta qué personas, lugares, estímulos y situaciones más te drenan.',
  image: 'https://cdn.magicpatterns.com/uploads/5XTcKBoePaCFBGDDcfp9Zg/BONO_1_-_¿Donde_se_esta_yendo_toda_mi_energia__page-0001.jpg'
}, {
  label: 'BONO 2',
  title: 'ANTES DE LLEGAR AL LÍMITE',
  description: 'Reconoce señales físicas, mentales y sensoriales antes de saturarte.',
  image: 'https://cdn.magicpatterns.com/uploads/5Pr163DEi3jyFQMm8vA74Q/BONO_2_-_Antes_de_llegar_al_limite_page-0001.jpg'
}, {
  label: 'BONO 3',
  title: 'CUANDO NO SABES CÓMO DECIRLO',
  description: 'Frases preparadas para pedir espacio, tiempo, límites o explicar sobrecarga.',
  image: 'https://cdn.magicpatterns.com/uploads/fqpEXoa8sEoBAVEXko1HJL/BONO_3_-_Cuando_no_sabes_como_decirlo_page-0001.jpg'
}, {
  label: 'BONO 4',
  title: 'CUANDO NADIE ENTIENDE LO QUE TE PASA',
  description: 'Una guía para comunicar tus necesidades a las personas cercanas.',
  image: 'https://cdn.magicpatterns.com/uploads/3H7LmWb7bfFV9UuuAfL8Uf/BONO_4_-_Cuando_nadie_entiende_lo_que_te_pasa_page-0001.jpg'
}, {
  label: 'BONO 5',
  title: 'NO TE QUEDES EN BLANCO EN LA CONSULTA',
  description: 'Organiza tu historia, experiencias y preguntas antes de hablar con un profesional.',
  image: 'https://cdn.magicpatterns.com/uploads/39rnWuNW85RQWLoG75w98g/BONO_5_-_No_te_quedes_en_blanco_en_la_consulta_page-0001.jpg'
}];
export const transformation = {
  titleLine1: 'IMAGINA PODER DEJAR',
  titleLine2: 'DE PENSAR “¿QUÉ ME PASA?”',
  outcomes: ['Reconocer qué situaciones consumen tu energía.', 'Detectar cuándo estás empezando a sobrecargarte.', 'Entender por qué algunas interacciones requieren recuperación.', 'Ponerle palabras a necesidades que antes solo sentías.', 'Mirar experiencias de tu pasado desde otro contexto.', 'Llegar a una consulta pudiendo explicar mejor lo que estás viviendo.'],
  closeLine1: '“AHORA ENTIENDO MEJOR',
  closeLine2: 'LO QUE ME PASA.”'
};
export const selfKnowledge = {
  titleLine1: 'AUTOCONOCIMIENTO,',
  titleLine2: 'NO UN DIAGNÓSTICO.',
  cards: [{
    title: 'NO NECESITAS DIAGNÓSTICO',
    text: 'Puedes utilizar el material para explorar experiencias y patrones.'
  }, {
    title: 'NO TIENES QUE IDENTIFICARTE CON TODO',
    text: 'Cada persona puede reconocer experiencias diferentes.'
  }, {
    title: 'NO REEMPLAZA UNA EVALUACIÓN PROFESIONAL',
    text: 'El contenido es educativo y de autoconocimiento.'
  }],
  note: 'Muchas de las experiencias abordadas pueden aparecer también fuera del autismo. Este material no determina si una persona es autista.'
};
export const testimonialsTitle = '“Pensé que eran cosas sueltas sobre mí… hasta que empecé a entender el patrón.”';
/** Testimonios PROVISIONALES: reemplazar por testimonios reales. Máximo 3. */
export const testimonials: Testimonial[] = [{
  quote: "Durante años llegaba a casa después de trabajar y no quería que nadie me hablara. Necesitaba silencio, oscuridad y estar sola. Pensaba que simplemente era demasiado sensible. Leer sobre masking y sobrecarga fue como verme explicada en páginas.",
  name: 'Sofía M.',
  age: '29 años'
}, {
  quote: "Siempre me decían: ‘pero si puedes trabajar, salir, hablar con la gente y hacer tu vida’. Y sí, puedo. Lo que nadie veía era cómo terminaba después. Por primera vez entendí que poder hacerlo no significa que hacerlo me cueste poco.",
  name: 'Diego R.',
  age: '38 años'
}, {
  quote: "Pensaba que reaccionaba demasiado por cosas pequeñas. Un ruido, un cambio de planes, una pregunta cuando ya estaba cansada… Ahora entiendo que muchas veces esa no era ‘la causa’: era simplemente lo último que podía procesar.",
  name: 'Lucía G.',
  age: '35 años'
}];
export const offerStack = {
  title: 'TODO LO QUE RECIBES HOY',
  items: ['6 tomos completos', '5 bonos prácticos', 'Acceso digital inmediato', 'Lectura desde celular, tablet o computadora', 'Garantía de 7 días'],
  terms: 'Pago único · Sin suscripciones'
};
export const guarantee = {
  title: 'GARANTÍA DE 7 DÍAS',
  lead: 'Accede al material, revísalo y decide.',
  body: 'Si dentro de los primeros 7 días sientes que no era lo que buscabas, puedes solicitar tu reembolso.',
  claim: 'TÚ REVISAS EL MATERIAL Y DECIDES.'
};
export const faqs: Faq[] = [{
  question: '¿Necesito tener un diagnóstico de autismo?',
  answer: 'No. Puedes usarlo si estás explorando esta posibilidad o si ya tienes un diagnóstico. El material no diagnostica.'
}, {
  question: '¿Este material puede decirme si soy autista?',
  answer: 'No. Es material educativo y de autoconocimiento. Un diagnóstico solo puede hacerlo un profesional mediante una evaluación.'
}, {
  question: '¿Tengo que leer los seis tomos seguidos?',
  answer: 'No. Puedes avanzar a tu ritmo y volver a cada tomo o ejercicio cuando lo necesites.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'De forma digital, inmediatamente después de completar tu compra.'
}, {
  question: '¿Puedo verlo desde el celular?',
  answer: 'Sí. También puedes leerlo desde tablet o computadora.'
}];
export const finalClose = {
  titleLines: ['PUEDES SEGUIR PREGUNTÁNDOTE', 'POR QUÉ CIERTAS COSAS', 'TE CUESTAN TANTO.'],
  thoughts: ['“Debería poder manejarlo.”', '“Seguro estoy exagerando.”', '“¿Por qué los demás pueden y yo termino agotado?”'],
  turnLine1: 'O PUEDES EMPEZAR A MIRAR TU HISTORIA',
  turnLine2: 'CON UN CONTEXTO QUE QUIZÁ NUNCA TUVISTE.',
  productLine: '6 TOMOS + 5 BONOS PRÁCTICOS',
  headlineLine1: 'EMPIEZA A ENTENDER',
  headlineLine2: 'LO QUE NADIE ESTABA VIENDO.',
  microcopy: 'Pago seguro · Acceso inmediato · Garantía de 7 días'
};
export const disclaimer = 'Este material tiene fines educativos y de autoconocimiento. No diagnostica autismo ni sustituye una evaluación profesional.';